import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { intlReducer } from 'react-intl-redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import { getQueryParam } from '../utils/get-query-param';
import messages from '../utils/intl-messages';
import reducers from '../reducers';

let mainStore = null;

export function configureStore() {
  let defaultLocale = localStorage.getItem(`${'remeha-config'}-locale`) || 'nl';
  const queryLocale = getQueryParam('lng', defaultLocale);
  const env = 'dev';

  if (queryLocale === 'en' || queryLocale === 'nl' || queryLocale === 'fr' || queryLocale === 'de') {
    defaultLocale = queryLocale;
  }

  const initialState = {
    intl: {
      locale: defaultLocale,
      messages: messages(defaultLocale),
    },
  };

  const rootReducer = combineReducers({
    ...reducers,
    intl: intlReducer,
    routing: routerReducer,
  });


  let enhancer;
  if (env === 'dev') {
    // eslint-disable-next-line no-underscore-dangle
    const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
    enhancer = composeEnhancers(
      applyMiddleware(promise, thunk),
    );
  } else {
    enhancer = compose(
      applyMiddleware(promise, thunk),
    );
  }

  const store = createStore(rootReducer, initialState, enhancer);

  return store;
}

export function makeStore() {
  mainStore = configureStore();
}

export function getStore() {
  return mainStore;
}



// WEBPACK FOOTER //
// ./js/store/index.js